import { requestsConstants } from './requests.constants';

const defaultState = {
	reportVisible: false,
	filterVisible: false,
	historyVisible: false,
	historyRequest: undefined,
	mapVisible: false,
	mapRequests: undefined,
	requests: [],
	reports: [],
	creationMethods: [],
	report: undefined,
	goResort: false,
	expiredList: false,
	showPreview: false,
	showModal: false,
	previewUrl: null, 
	previewFileName: null, 
	currentPreview:0,
	previews:[],
	showModalStage: null,
  importResult: null,
  importResultRequests: [],
	requestsFailedValue: undefined,
	requestsFailedFile: undefined,
	showModalChess: null,
	activeRequest: null,
}

export default (state = defaultState, action = {}) => {
	switch (action.type) {
		case requestsConstants.SHOW_MODAL: {
			return {
				...state,
				showModal: true,
			}
		}
	case requestsConstants.SET_SHOW_MODAL_CHESS: {
			return {
				...state,
				showModalChess: action.payload,
			}
		}
		case requestsConstants.SET_SHOW_MODAL_STAGE: {
			return {
				...state,
				showModalStage: action.payload
			}
		}
		case requestsConstants.HIDE_MODAL: {
			return {
				...state,
				showModal: false,
			}
		}
		case requestsConstants.SET_REQUESTS_FAILED_VALUE: {
			return {
				...state,
				requestsFailedValue: action.payload,
			}
		}
		case requestsConstants.SET_FAILED_FILE_FETCH_DATA + '_FULFILLED': {
			return {
				...state,
				requestsFailedFile: action.payload
			}
		}
		case requestsConstants.SET_FAILED_FILE_FETCH_CLEAR: {
			return {
				...state,
				requestsFailedFile: undefined,
			}
		}
		case requestsConstants.SHOW_PREVIEW: {
			return {
				...state,
				showPreview: true,
				previewUrl: action.payload.url,
				previewFileName: action.payload.fileName,
				currentPreview: action.payload.currentPreview, 
				previews: action.payload.previews,
			}
		}
		case requestsConstants.HIDE_PREVIEW: {
			return {
				...state,
				showPreview: false,
				currentPreview: 0,
				previews: [],
			}
		}
		case requestsConstants.SET_PREVIEW_INDEX: {
			return {
				...state,
				currentPreview: action.payload.currentPreview, 
			}
		}
		case requestsConstants.POST_ERROR: {
			return {
				...state,
				dataFetching: false,
				apiResponseError: 'Ошибка при добавлении заявки',
				apiResponseText: action.payload,
			}
		}
		case requestsConstants.UNSET_RESORT: {
			return {
				...state,
				goResort: false
			}
		}

		case requestsConstants.SET_SUBSERVICE_VALUE: {
			return {
				...state,
				valueSubservice: action.payload
			}
		}
		case requestsConstants.SET_REPORT: {
			return {
				...state,
				report: action.payload
			}
		}
		case requestsConstants.FETCH_EXPIRED_REQUESTS + '_FULFILLED': {
		return {
			...state,
			requests: action.payload ? (action.payload.data.data || action.payload.data) : [],
			goResort: true,
			dataFetching: false,
			apiResponseError: null
		}
	}
	case requestsConstants.MARK_REQUEST_COMMENTED + '_FULFILLED': 
	case requestsConstants.MARK_REQUEST_VIEWED + '_FULFILLED': 
	case requestsConstants.SET_REQUEST_EXECUTE_TIME + '_FULFILLED': 
	case requestsConstants.SET_REQUEST_INVOICE + '_FULFILLED': 
	case requestsConstants.SET_REQUEST_EXECUTER + '_FULFILLED': 
	case requestsConstants.SET_REQUEST_MASTER + '_FULFILLED': 
	case requestsConstants.SET_REQUEST_SERVICE + '_FULFILLED': 
	case requestsConstants.SET_REQUEST_RATING + '_FULFILLED': 
	case requestsConstants.SET_REQUEST_ADDRESS + '_FULFILLED':
	case requestsConstants.SET_REQUEST_STATUS + '_FULFILLED': 
	case requestsConstants.FETCH_REQUESTS + '_FULFILLED': {			
			return {
				...state,
				requests: action.payload ? (action.payload.data.data || action.payload.data) : [],
				goResort: true,
				dataFetching: false,
				apiResponseError: null
			}
		}
		case requestsConstants.FETCH_EXPIRED_REQUESTS + '_PENDING': {
				return {
					...state,
					expiredList: true,
					dataFetching: true
				}
			}
		case requestsConstants.MARK_REQUEST_COMMENTED + '_PENDING': 
		case requestsConstants.MARK_REQUEST_VIEWED + '_PENDING': 
		case requestsConstants.SET_REQUEST_EXECUTE_TIME + '_PENDING': 
		case requestsConstants.SET_REQUEST_INVOICE + '_PENDING': 
		case requestsConstants.SET_REQUEST_EXECUTER + '_PENDING': 
		case requestsConstants.SET_REQUEST_MASTER + '_PENDING': 
		case requestsConstants.SET_REQUEST_SERVICE + '_PENDING': 
		case requestsConstants.SET_REQUEST_RATING + '_PENDING': 
		case requestsConstants.SET_REQUEST_ADDRESS + '_PENDING':
		case requestsConstants.SET_REQUEST_STATUS + '_PENDING': {
				return {
				...state,
				dataFetching: true
			}
		}
		case requestsConstants.FETCH_REQUESTS + '_PENDING': {
			return {
				...state,
				expiredList: false,
				dataFetching: true
			}
		}
		case requestsConstants.CLOSE_FILTER: {
			return {
				...state,
				filterVisible: action.payload
			}
		}
		case requestsConstants.HISTORY_OPEN: {
			return {
				...state,
				historyVisible: true,
				historyRequest: action.payload
			}
		}
		case requestsConstants.HISTORY_CLOSE: {
			return {
				...state,
				historyVisible: false,
				historyRequest: undefined,
			}
		}
		case requestsConstants.MAP_OPEN: {
			return {
				...state,
				mapVisible: true,
				mapRequests: action.payload
			}
		}
		case requestsConstants.MAP_CLOSE: {
			return {
				...state,
				mapVisible: false,
				mapRequests: undefined,
			}
		}
		case requestsConstants.CLOSE_REPORT: {
			return {
				...state,
				reportVisible: action.payload
			}
		}
		case requestsConstants.SET_REPORTS + '_FULFILLED': {
			return {
				...state,
				reports: action.payload.data.data || action.payload.data
			}
		}
		case requestsConstants.SET_CREATION_METHODS + '_FULFILLED': {
			return {
				...state,
				creationMethods: action.payload
			}
		}
		case requestsConstants.SET_REPORTS +'_REJECTED':
    case requestsConstants.SET_CREATION_METHODS + '_REJECTED':
		case requestsConstants.SET_REQUEST_EXECUTE_TIME + '_REJECTED': 
		case requestsConstants.SET_REQUEST_INVOICE + '_REJECTED': 
		case requestsConstants.SET_REQUEST_EXECUTER + '_REJECTED': 
		case requestsConstants.SET_REQUEST_MASTER + '_REJECTED': 
		case requestsConstants.SET_REQUEST_SERVICE + '_REJECTED': 
		case requestsConstants.SET_REQUEST_RATING +'_REJECTED': 
		case requestsConstants.SET_REQUEST_STATUS +'_REJECTED': 		
		case requestsConstants.SET_REQUEST_ADDRESS + '_REJECTED':
		case requestsConstants.FETCH_REQUESTS +'_REJECTED': 
		case requestsConstants.FETCH_EXPIRED_REQUESTS +'_REJECTED': {			
			return {
				...state,
				dataFetching: false,
				apiResponseError: (action.payload.response && action.payload.response.status) || action.payload,
				apiResponseText: action.payload.response && action.payload.response.statusText
			}
		}
		case requestsConstants.UPDATE_REQUESTS: {
			return {
				...state,
				requests: action.payload
			}
		}
		case requestsConstants.RETRIEVE_LAST_STATE: {
			return {
				...state,
				...action.payload
			}
		}
    case requestsConstants.SET_IMPORT_RESULT: {
      return {
        ...state,
        importResult: action.payload,
      };
    }
    case requestsConstants.SET_IMPORT_RESULT_REQUESTS + '_FULFILLED': {
      return {
        ...state,
        importResultRequests:
          action.payload?.data?.data || action.payload?.data || action.payload,
      };
    }
		case requestsConstants.SET_ACTIVE_REQUEST: {
			return {
				...state,
				activeRequest: action.payload
			}
		}
		default:
			return state;
	}
}